import React from 'react'
import converseValues from '../../../images/converseValues/1_WIP_RetailLab-264_V2 1.png'

const ConverseValues = () => {
	return (
		<div className='section-black ncss-row'>
			<div className='about-maxims section-container' style={{ margin: '32px 0px 64px' }}>
				<div className='ncss-col-sm-6 section-block'>
					<img
						src={converseValues}
						alt='Converse Values'
						style={{
							borderRadius: '16px',
							minWidth: '380px',
							height: 'auto',
						}}
					/>
				</div>
				<div className='ncss-col-sm-6 section-block' style={{ maxWidth: '610px', minWidth: '380px' }}>
					<h1 className='section-title'>The Values</h1>
					<p className='section-p'>
						Our Values represent the beliefs and behaviors that lie at the heart of everything we do. These five simple,
						actionable phrases capture what drives us forward as a Brand.
					</p>
				</div>
			</div>
		</div>
	)
}

export default ConverseValues



// WEBPACK FOOTER //
// ./src/containers/AboutPage/ConverseValues/Values.js